import React from "react";
import { CPreloader } from "../../UI";
import "./style.scss";

const LoadMoreButton = ({isLoading, onClick, isShow, title, isBorder}) => {
    const className = "loading-more";

    if (!isShow) {
        return null;
    }

    return (
        <div className={`${className} ${isBorder ? '-border' : ''}`}>
            {isLoading ? (
                <div className={`${className}-loading`}>
                    <CPreloader />
                </div>
            ) : (
                <div onClick={onClick} className={`${className}-button`}>
                    {title}
                </div>
            )}
        </div>
    );
};

export default LoadMoreButton;
